export default [{ singular: 'en', plural: ['två', 'tre', 'ett par', 'sju'] }]
